import cn from 'classnames';
import React from 'react';

interface DSSwitchProps {
	label?: string;
	checked: boolean;
	onChange: (checked: boolean) => void;
}

export const DSSwitch: React.FC<DSSwitchProps> = ({ label, checked, onChange }) => {
	const backgroundClasses = () => {
		if (checked) {
			return 'fill-success-500';
		} else {
			return 'fill-gray-200 dark:fill-dark-500';
		}
	};

	const circleClasses = () => {
		if (checked) {
			return 'translate-x-[14px]';
		}
	};

	return (
		<label
			onClick={() => {
				onChange(!checked);
			}}
			className="flex items-center gap-2 cursor-pointer"
		>
			<svg className="w-9 h-5" viewBox="0 0 36 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<rect className={backgroundClasses()} width="36" height="20" rx="10" />
				<circle className={cn('fill-white transition-all', circleClasses())} cx="11" cy="10" r="8" />
			</svg>
			{label && <span className="text-gray-700 dark:text-gray-300">{label}</span>}
		</label>
	);
};
